<swiper-container
  navigation-next-el="#my-next-button"
  navigation-prev-el="#my-prev-button"
  navigation="true"
  loop="true"
  class="swiper-container"
>

  <!-- TODO deve essere parametrizzabile -->
  <swiper-slide #slide1 class="h-full grid grid-cols-5 py-0 px-10">

    <ng-container *ngFor="let prestazione of prestazioni1">
      <app-admin-calendar
        [prestazione]="prestazione"
      />
    </ng-container>

  </swiper-slide>

  <swiper-slide #slide2 class="h-full grid grid-cols-5 py-0 px-10">
    <ng-container *ngFor="let prestazione of prestazioni2">
      <app-admin-calendar
        [prestazione]="prestazione"
      />
    </ng-container>
  </swiper-slide>

</swiper-container>

<button id="my-next-button" class="my-next-button">Next</button>
<button id="my-prev-button" class="my-prev-button">Prev</button>
